import { styled } from "goober";
import { SelectControl } from "@wordpress/components";

export const StyledSelectControl = styled(SelectControl)`

select {
  width: min-content !important;
  background: transparent;
  box-sizing: border-box;
  border: none;
  color: rgb(30, 30, 30);
  display: block;
  font-family: inherit;
  margin: 0px;
  max-width: none;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  height: 32px;
  min-height: 32px;
  padding: 0px 26px 0px 8px;
  overflow: hidden;
  box-shadow: none !important;
  border: 0;
  margin-bottom: 0;
}

  .components-input-control__backdrop {
    display: none;
  }

`;